var rootMenu = document.querySelector("#root-menu"); // main menu
var productsLi = rootMenu.firstElementChild; //products in menu
var submenu = document.querySelector("#submenu-content-container"); // mega menu middle and right part
var submenuLi = submenu.querySelectorAll(".submenu-list");  //mega menu middle part
var megaContainer = productsLi.querySelector('.mega-menu-container'); //whole mega menu container
var megaLeftImage = megaContainer.querySelector('.image-container'); // mega menu left part image container
var containerH = 0;
var leftBlock= document.querySelector(".left-image");
productsLi.addEventListener("mouseenter", (event) => {
  megaContainer.style.display = "block";
  var megaContainerH = megaContainer.offsetHeight;
submenuLi[0].querySelector('.submenu-container').style.display = "block";
  leftBlock.style.background = "url("+getImageurl(submenuLi[0])+")"; 
  for (var i = 0; i < submenuLi.length; i++) {
    submenuLi[i].addEventListener("mouseover", () => {
      this.querySelector('.submenu-container').style.display = "block";
      leftBlock.style.background = "url("+getImageurl(this)+")";
      var megaSubmenuH=this.querySelector('.submenu-container').offsetHeight;
      containerH = megaContainerH > megaSubmenuH ? megaContainerH : megaSubmenuH;
      megaContainer.style.height = containerH + "px";
      megaLeftImage.style.height = containerH + "px";
      this.querySelector('.submenu-container').style.height = containerH + "px";
    });
    submenuLi[i].addEventListener("mouseleave", () => {
       this.querySelector('.submenu-container').style.display = "none";
    });
  }
});
productsLi.addEventListener("mouseleave", (event) => {
  megaContainer.style.display = "none";
});
function getImageurl(item){
  var url= item.querySelector("img").src;
  return url
}
// var carouselWrapper = document.querySelector(".carousel-wrapper");
// console.dir(carouselWrapper)
// var hSlide = carouselWrapper.querySelector(".swiper-slide").offsetHeight;
// var swiperSlide = carouselWrapper.querySelectorAll(".swiper-slide");
// console.dir(swiperSlide)
// console.log(hSlide)
// swiperSlide.forEach((item)=>{
//   item.querySelector('img').style.maxHeight = hSlide + "px";
// })
  
